import { Box, useTheme } from "@mui/material"
import { Header } from "./Header"
import { HeaderLogo } from "./HeaderLogo"
import { HeaderTitle } from "./HeaderTitle"
import { Clock } from "components/Clock"
import { BackIconButton, ShareIconButton } from "components/Button"
import { useAppUI } from "providers/ui"
import { LanguageButton } from "components/Language"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import { SearchToggleButton } from "components/domains/search"
import { useTranslation } from "providers/i18n"

export const LegacyHeader = () => {
  const { goBack, openSearch, openSearchState } = useAppUI()
  const theme = useTheme()
  const { t } = useTranslation()
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { headerBackIconContainer } = styleOverrides

  return (
    <Header
      logo={<HeaderLogo />}
      title={<HeaderTitle />}
      clock={<Clock />}
      backButton={
        <Box sx={headerBackIconContainer}>
          <BackIconButton onClick={goBack} />
        </Box>
      }
      languageButton={<LanguageButton endIcon={<ExpandMoreIcon />} />}
      searchButton={
        <SearchToggleButton
          placeholder={t("Search")}
          onClick={openSearch}
          sx={{ visibility: openSearchState ? "hidden" : "visible" }}
        />
      }
      shareButton={
        <ShareIconButton
          url={window.location.href}
          text={t("ShareButton.text")}
        />
      }
    />
  )
}
